import script from "./personal.vue?vue&type=script&lang=ts&setup=true"
export * from "./personal.vue?vue&type=script&lang=ts&setup=true"

import "./personal.vue?vue&type=style&index=0&id=d67a4e08&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.2.2_@vue+compiler-sfc@3.4.27_vue@3.2.36_webpack@5.88.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d67a4e08"]])

export default __exports__